var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotaDataNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.6,
    height: 104.07,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 362.6 104.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".k{fill:url(#f);}.l{fill:url(#g);}.m{fill:url(#i);}.n{fill:#2fb2d1;}.o{fill:url(#h);}.p{fill:url(#d);}.q{fill:url(#e);}.r{fill:#5eb56b;}.s{fill:none;}.t{fill:#1f81bc;}.u{fill:url(#j);}.v{fill:#055282;}.w{fill:#373f4a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 126.55,
    y1: 5047.22,
    x2: 321.64,
    y2: 5042.51,
    gradientTransform: "translate(0 -5032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14162c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#13243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#155682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1875ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1b81bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1c85be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2193c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2ba9cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2fb2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 126.84,
    y1: 5046.61,
    x2: 321.94,
    y2: 5041.9,
    gradientTransform: "translate(0 -5032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14162c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#15507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1b81bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1f8ec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2eafcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2fb2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#42b2a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58b36e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 125.15,
    y1: 5051.85,
    x2: 320.25,
    y2: 5047.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 121.51,
    y1: 5063.85,
    x2: 316.6,
    y2: 5059.15,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 93.85,
    y1: 5083.01,
    x2: 288.94,
    y2: 5078.31,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -103.92,
    y1: 5103.51,
    x2: 338.9,
    y2: 5039.34,
    gradientTransform: "translate(0 -5032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#065283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1374ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1b81bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1c85be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2193c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2ba9cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2fb2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -58.98,
    y1: 5084.42,
    x2: 383.84,
    y2: 5020.24,
    gradientTransform: "translate(0 -5032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14162c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#13243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#155682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1875ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1b81bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1c85be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2193c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2ba9cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2fb2d1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 178.2,
    cy: 13.97,
    r: 13.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M217.7,1.77c-2.9-1.7-6.3-2.2-9.5-1.4-6.7,1.7-10.8,8.6-9.1,15.3,.8,3.3,2.9,6,5.8,7.7,2.9,1.7,6.3,2.2,9.5,1.4,6.7-1.7,10.8-8.6,9.1-15.3-.9-3.3-2.9-6-5.8-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M249.8,7.77c-2.5-2-5.6-2.9-8.7-2.5-6.5,.7-11.2,6.6-10.5,13.1,.3,3.1,1.9,6,4.4,7.9,2.5,2,5.6,2.9,8.7,2.5,6.5-.7,11.2-6.6,10.5-13.1-.4-3.1-1.9-5.9-4.4-7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M277.5,20.67c-2-2-4.7-3.1-7.5-3.1-5.9,0-10.7,4.8-10.7,10.7,0,2.8,1.1,5.5,3.1,7.6,2,2,4.7,3.1,7.5,3.1,5.9,0,10.7-4.8,10.7-10.7,.1-2.9-1-5.6-3.1-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M290.4,38.17c-4.5,0-8.1,3.6-8.1,8.1,0,2.2,.8,4.2,2.4,5.7,1.5,1.5,3.6,2.4,5.7,2.4,4.5,0,8.1-3.6,8.1-8.1s-3.7-8.1-8.1-8.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M64,67.57c-.9-2.3-2.1-4.2-3.7-5.7-1.5-1.5-3.3-2.6-5.4-3.3-2.1-.7-4.2-1-6.5-1-2.8,0-5.4,.4-7.7,1.3s-4.7,2.3-7,4.3c-1.6-1.8-3.5-3.2-5.7-4.2s-4.3-1.5-6.4-1.5c-1.9,0-3.8,.4-5.7,1.2-1.9,.8-3.5,1.9-4.9,3.2v-3.3H0v44.1H11v-32c1.4-1.3,2.7-2.2,4-2.8,1.3-.6,2.8-.9,4.4-.9,2.1,0,4,.8,5.4,2.4,1.5,1.6,2.3,4,2.3,7.1v26.3h11v-26.3c0-2.2-.2-4.2-.7-6,1.4-1.2,2.9-2.1,4.4-2.6s3.1-.8,4.8-.8c2.2,0,4,.8,5.5,2.4s2.3,4,2.3,7.1v26.3h11v-26.9c-.1-3.3-.5-6.1-1.4-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M147.5,93.67c-1.2,.3-2.3,.5-3.1,.5-.7,0-1.3-.1-1.9-.2s-1.1-.4-1.6-.8c-.4-.4-.8-1-1.1-1.7s-.4-1.6-.4-2.8v-20.1h11.1v-9.9h-11.1v-12.9h-3.6c-.8,4.6-2.3,8.4-4.5,11.3s-5.1,5.1-8.7,6.6v5h5.8v19.3c0,2.8,.2,5.1,.7,7.2,.5,2,1.3,3.7,2.3,5,1.1,1.3,2.5,2.3,4.3,2.9s4,1,6.6,1c1.5,0,3-.2,4.4-.5,1.5-.4,2.8-.9,3.9-1.6v-9.7c-.8,.6-1.8,1.1-3.1,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M191.8,69.27c-.8-2.4-2.1-4.5-4.1-6.5-1.5-1.5-3.4-2.8-5.8-3.7-2.4-1-5.1-1.5-8.2-1.5-3.3,0-6.4,.6-9.5,1.8-3.1,1.2-5.8,3-8.1,5.2l6.5,6.6c1.6-1.5,3.2-2.5,4.9-3.1,1.6-.6,3.2-.8,4.7-.8,3.2,0,5.6,.8,7.3,2.3s2.5,3.6,2.5,6.2h-6.3c-2.9,0-5.6,.3-8.1,.9s-4.7,1.5-6.6,2.8c-1.9,1.2-3.4,2.8-4.5,4.7-1.1,1.9-1.6,4-1.6,6.5,0,2,.4,3.8,1,5.4,.7,1.6,1.7,3,2.9,4.2,1.3,1.2,2.8,2.1,4.5,2.7s3.7,1,5.8,1c2.3,0,4.5-.3,6.7-.8s4.2-1.4,6.1-2.8v2.4h11v-24.4c0-3.7-.3-6.7-1.1-9.1h0Zm-9.9,22.6c-1.6,1-3.2,1.7-4.8,2.2s-3.2,.8-4.9,.8c-1.9,0-3.4-.5-4.6-1.4-1.2-1-1.8-2.2-1.8-3.7,0-1.1,.3-2,.9-2.7,.6-.8,1.4-1.4,2.4-1.9s2.2-.8,3.5-1,2.8-.3,4.3-.3h5v8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M231.2,39.47v20.9c-1.3-.9-2.8-1.6-4.6-2.1s-3.6-.8-5.5-.8c-2.7,0-5.3,.6-7.9,1.8-2.5,1.2-4.8,2.8-6.8,4.9s-3.6,4.5-4.8,7.4c-1.2,2.8-1.8,5.9-1.8,9.2,0,3.1,.5,6.1,1.6,8.9,1,2.8,2.5,5.3,4.4,7.4s4.1,3.8,6.7,5c2.6,1.2,5.4,1.9,8.5,1.9,1.9,0,3.7-.3,5.3-.8,1.7-.5,3.2-1.4,4.7-2.5v2.3h11.2V39.47h-11Zm.1,51.5c-2.5,2.2-5.2,3.3-8.1,3.3-1.8,0-3.4-.3-4.9-1s-2.8-1.6-3.9-2.8c-1.1-1.2-1.9-2.6-2.5-4.3-.6-1.6-.9-3.5-.9-5.5s.3-3.9,.9-5.6c.6-1.7,1.5-3.1,2.6-4.3,1.1-1.2,2.4-2.1,3.9-2.8,1.5-.6,3.2-1,5-1,.6,0,1.2,.1,1.9,.2s1.4,.3,2.1,.5c.7,.2,1.4,.5,2.1,.8s1.3,.7,1.8,1v21.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M286.1,69.27c-.8-2.4-2.1-4.5-4.1-6.5-1.5-1.5-3.4-2.8-5.8-3.7s-5.1-1.5-8.2-1.5c-3.3,0-6.4,.6-9.5,1.8-3.1,1.2-5.8,3-8.1,5.2l6.5,6.6c1.6-1.5,3.2-2.5,4.9-3.1,1.6-.6,3.2-.8,4.7-.8,3.2,0,5.6,.8,7.3,2.3,1.7,1.5,2.5,3.6,2.5,6.2h-6.3c-2.9,0-5.6,.3-8.1,.9s-4.7,1.5-6.6,2.8c-1.9,1.2-3.4,2.8-4.5,4.7-1.1,1.9-1.6,4-1.6,6.5,0,2,.4,3.8,1,5.4,.7,1.6,1.7,3,2.9,4.2,1.3,1.2,2.8,2.1,4.5,2.7,1.7,.6,3.7,1,5.8,1,2.3,0,4.5-.3,6.7-.8s4.2-1.4,6.1-2.8v2.4h11v-24.4c.1-3.7-.3-6.7-1.1-9.1h0Zm-9.8,22.6c-1.6,1-3.2,1.7-4.8,2.2-1.6,.5-3.2,.8-4.9,.8-1.9,0-3.4-.5-4.6-1.4-1.2-1-1.8-2.2-1.8-3.7,0-1.1,.3-2,.9-2.7,.6-.8,1.4-1.4,2.4-1.9s2.2-.8,3.5-1,2.8-.3,4.3-.3h5v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M317.2,93.67c-1.2,.3-2.3,.5-3.1,.5-.7,0-1.3-.1-1.9-.2s-1.1-.4-1.6-.8-.8-1-1.1-1.7c-.3-.7-.4-1.6-.4-2.8v-20.1h11.1v-9.9h-11.1v-12.9h-3.6c-.8,4.6-2.3,8.4-4.5,11.3s-5.1,5.1-8.7,6.6v5h5.8v19.3c0,2.8,.2,5.1,.7,7.2,.5,2,1.3,3.7,2.3,5,1.1,1.3,2.5,2.3,4.3,2.9s4,1,6.6,1c1.5,0,3-.2,4.4-.5,1.5-.4,2.8-.9,3.9-1.6v-9.7c-.8,.6-1.9,1.1-3.1,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M361.4,69.27c-.8-2.4-2.1-4.5-4.1-6.5-1.5-1.5-3.4-2.8-5.8-3.7s-5.1-1.5-8.1-1.5c-3.3,0-6.4,.6-9.5,1.8-3.1,1.2-5.8,3-8.1,5.2l6.5,6.6c1.6-1.5,3.2-2.5,4.9-3.1,1.6-.6,3.2-.8,4.7-.8,3.2,0,5.6,.8,7.3,2.3,1.7,1.5,2.5,3.6,2.5,6.2h-6.3c-2.9,0-5.6,.3-8.1,.9s-4.7,1.5-6.6,2.8c-1.9,1.2-3.4,2.8-4.5,4.7-1.1,1.9-1.6,4-1.6,6.5,0,2,.4,3.8,1,5.4,.7,1.6,1.7,3,2.9,4.2,1.3,1.2,2.8,2.1,4.5,2.7s3.7,1,5.8,1c2.3,0,4.5-.3,6.7-.8s4.2-1.4,6.1-2.8v2.4h11v-24.4c0-3.7-.4-6.7-1.2-9.1h0Zm-9.8,22.6c-1.6,1-3.2,1.7-4.8,2.2-1.6,.5-3.2,.8-4.9,.8-1.9,0-3.4-.5-4.6-1.4-1.2-1-1.8-2.2-1.8-3.7,0-1.1,.3-2,.9-2.7,.6-.8,1.4-1.4,2.4-1.9s2.2-.8,3.5-1,2.8-.3,4.3-.3h5v8h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M104.9,28.37c-6.3,5.4-7,15-1.6,21.3,5.4,6.3,15,7,21.3,1.6s7-15,1.6-21.3-15-7-21.3-1.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "u",
    cx: 145.6,
    cy: 22.77,
    r: 13.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M85.83,89.32c2.48,2.68,6.03,4.35,9.97,4.35,.43,0,.85-.02,1.26-.06,1.8-.16,3.5-.68,5.03-1.48,4.35-2.26,7.31-6.81,7.31-12.06,0-7.51-6.08-13.6-13.6-13.6-5.78,0-10.71,3.6-12.68,8.69-.6,1.52-.92,3.18-.92,4.91,0,3.57,1.37,6.82,3.63,9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M95.8,93.67c-3.94,0-7.49-1.67-9.97-4.35l-7.62,7.07c4.38,4.73,10.64,7.68,17.59,7.68,.75,0,1.5-.03,2.23-.1l-.97-10.36c-.41,.04-.83,.06-1.26,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M95.8,56.07c-10.19,0-18.91,6.36-22.37,15.33l9.69,3.76c1.97-5.09,6.9-8.69,12.68-8.69,7.52,0,13.6,6.09,13.6,13.6,0,5.25-2.96,9.8-7.31,12.06l4.8,9.22c7.68-3.99,12.91-12.02,12.91-21.28,0-13.25-10.74-24-24-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M82.2,80.07c0-1.73,.32-3.39,.92-4.91l-9.69-3.76c-1.06,2.69-1.63,5.61-1.63,8.67,0,6.31,2.43,12.04,6.41,16.32l7.62-7.07c-2.26-2.43-3.63-5.68-3.63-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M97.06,93.61l.97,10.36c3.18-.3,6.17-1.21,8.86-2.62l-4.8-9.22c-1.53,.8-3.23,1.32-5.03,1.48Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotaDataNew);
export default __webpack_public_path__ + "static/media/Mota-Data-new.f10982c7452cbac4c907007b4d6f348d.svg";
export { ForwardRef as ReactComponent };